<template>
  <div class="block-play-image-gallery">
    <div class="block-play-image-gallery__inner">
      <div class="block-play-image-gallery__header">
        <AtomTextHeading
          v-if="title"
          class="block-play-image-gallery__title"
          font-size="h3"
          html-tag="h2"
          :text="title"
        />

        <!-- <div class="block-play-image-gallery__tabs">
          <AtomButton
            v-for="(button, index) in tabs"
            :key="`image-gallery-tab-button-${index}`"
            class="block-play-image-gallery__header-tab"
            :text="button.label"
            :is-inactive-tab="activeTab !== button.name"
            :is-active-tab="activeTab === button.name"
            @click="activeTab = button.name"
          />
        </div> -->
      </div>

      <div class="block-play-image-gallery__content">
        <div
          v-if="currentTab && !isArrayNotEmpty(images) && !isInitial"
          class="block-play-iamge-gallery__no-result"
        >
          <AtomTextRichtext
            :html="currentTab?.noResultsText"
          />

          <UtilRouteLink
            v-if="currentTab?.noResultsCtaLink"
            :link="currentTab?.noResultsCtaLink"
          >
            <AtomButton
              :text="currentTab?.noResultsCtaText"
            />
          </UtilRouteLink>
        </div>

        <BlockMasonryImages
          :images="images"
        />

        <AtomButton
          v-if="total && images.length < total"
          :text="loadMoreText"
          :is-disabled="pending"
          @click="page += 1"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
    title: {
        type: String,
        default: '',
    },

    tabs: {
        type: Array,
        default: () => [],
    },

    loadMoreText: {
        type: String,
        default: 'Mehr laden',
    },
});

const activeTab = ref(
    props.tabs?.length
        ? props.tabs[0].name
        : 'all',
);

const page = ref(1);
const pageSize = ref(15);
const total = ref(0);
const images = ref([]);
const isReset = ref(false);
const isInitial = ref(true);

const currentTab = computed(() => {
    if (!isArrayNotEmpty(props.tabs)) return null;

    return props.tabs.find(
        (tab) => tab.name === activeTab.value,
    );
});

const { pending, error } = useLazyAsyncData(
    'photowall',
    async () => useGetPhotoUploads({
        page: page.value,
        pageSize: pageSize.value,
        onlyMe: activeTab.value !== 'all',
    }),
    {
        transform: (res) => {
            if (!isArrayNotEmpty(res.entries)) return {};

            if (isReset.value) {
                images.value = [];
                isReset.value = false;
            }

            total.value = res.pagination.total;

            const mappedImages = res.entries.map((entry) => ({
                image: {
                    src: entry.image.url,
                    alt: entry.image.alt,
                    width: entry.image.width,
                    height: entry.image.height,
                },
                user: entry.user,
            }));

            images.value = [...images.value, ...mappedImages];
            isInitial.value = false;
            return res;
        },
        watch: [page, activeTab],
        server: false,
    },
);

watch(() => error.value, (newValue) => {
    if (newValue) {
        useSentryError(error.value, {
            useThrow: false,
        });
    }
});

watch(() => activeTab.value, () => {
    isReset.value = true;
    page.value = 1;
});
</script>

<style lang="scss" scoped>
.block-play-image-gallery {
    @include wrapper-layout;
    @include grid-layout;

    margin-bottom: var(--m-bottom--big);
}

.block-play-image-gallery__inner {
    @include default-content-columns('wide');
    @include box-default;

    display: flex;
    flex-direction: column;
    row-gap: 20px;
}

.block-play-image-gallery__header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    column-gap: 20px;
    row-gap: 20px;
}

.block-play-image-gallery__title {
    display: flex;
    min-height: 48px;
    align-items: center;
}

.block-play-image-gallery__tabs {
    display: flex;
    width: 100%;
    column-gap: 10px;
}

.block-play-image-gallery__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 20px;
}

.block-play-iamge-gallery__no-result {
    display: flex;
    flex-direction: column;
    align-self: flex-start;
    padding-top: 10px;
    padding-bottom: 10px;
    color: var(--c-primary);
    font-family: var(--f-family--primary);
    font-size: var(--f-size--p);
    font-weight: var(--f-weight--500);
    line-height: var(--l-height--p);
    row-gap: 15px;
}
</style>
